export default __webpack_public_path__ + "64b780470e470af54a0cd3c337b08675.png";